import type { ChangeRequestConfig } from '@features/change-request/api/create-change-request/createChangeRequest.types';

export const HELP_CHANGE_REQUEST_CONFIG: ChangeRequestConfig = {
  type: 'MainHelpRequest',
  metadata: null,
};
